import Cloud from '../../../../shared/assets/images/png/cloud.png';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import { MenuItemProps as Props } from '../../../../shared/types/props/menu';

const DiskCapacityCloud = styled.img<Props>``;

DiskCapacityCloud.defaultProps = {
  src: Cloud,
};

export default withImage(DiskCapacityCloud, false);
